import { useMemo as w } from "react";
import { useBreakpoints as T } from "./atoms-v251.js";
import { DEFAULT_MAX_YEARS as E } from "./atoms-v2776.js";
function P(e, t) {
  return e === 1 ? t - 1 : t;
}
function A(e) {
  return e === 1 ? 12 : e - 1;
}
function R(e, t) {
  const c = /* @__PURE__ */ new Date(), h = c.getFullYear(), x = c.getMonth(), D = e.maxYears || E, Y = e.text.months.length, d = e.text.weekdays.length;
  let a = h;
  const m = [];
  for (let i = 0; i <= D; i++) {
    for (let n = i === 0 ? x : 0; n < Y; n++) {
      if (i === D && n >= x)
        continue;
      const f = n + 1, $ = new Date(a, f, 0), M = new Date(
        P(f, a),
        A(f),
        0
      ), r = $.getDate(), k = M.getDate(), o = M.getDay() === d - 1 ? 0 : M.getDay() + 1, v = Math.ceil((r + o) / d), I = [];
      let s = 1;
      for (let l = 1; l <= v; l++) {
        const u = {
          dates: []
        };
        for (let p = 1; p <= d; p++) {
          const C = s - o, g = {
            cellUID: `${a}-${n}-${C}`,
            isNextMonth: !1,
            isPreviousMonth: !1,
            value: C
          };
          if (l === 1 && s <= o)
            u.dates.push({
              ...g,
              cellUID: `${n - 1 < 0 ? a - 1 : a}-${n - 1 < 0 ? 11 : n - 1}-${k - o + s}`,
              isNextMonth: !1,
              isPreviousMonth: !0,
              value: k - o + s
            });
          else if (l === v && s > r + o)
            u.dates.push({
              ...g,
              cellUID: `${n + 1 > 11 ? a + 1 : a}-${n + 1 > 11 ? 0 : n + 1}-${s - r - o}`,
              isNextMonth: !0,
              isPreviousMonth: !1,
              value: s - r - o
            });
          else {
            if (s > r + o)
              continue;
            u.dates.push({
              ...g
            });
          }
          s += 1;
        }
        I.push(u);
      }
      const y = {
        month: {
          daysCount: r,
          monthUID: `${a}-${n}`,
          value: n,
          weeks: I
        },
        value: a
      };
      m.push(y);
    }
    a += 1;
  }
  return m;
}
function S(e) {
  let t = 8;
  switch (e) {
    case "small":
      t = 8;
      break;
    case "medium":
    case "large":
      t = 32;
      break;
    case "xLarge":
      t = 16;
      break;
    case "max":
    case "maxPlus":
      t = 32;
      break;
    default:
      t = 8;
      break;
  }
  return t;
}
function O({ config: e }) {
  const { current: t } = T(), c = w(() => R(e), []), h = w(() => S(t), [t]);
  return {
    calendarYearConfigs: c,
    isPriceShown: e.isPriceShown,
    tableMarginWidth: h,
    text: e.text
  };
}
export {
  R as createCalendar,
  S as getMarginWidth,
  O as useDOMBuilder
};
